import { render, staticRenderFns } from "./SettingNicknameComponent.vue?vue&type=template&id=29eca157&scoped=true"
import script from "./SettingNicknameComponent.vue?vue&type=script&lang=js"
export * from "./SettingNicknameComponent.vue?vue&type=script&lang=js"
import style0 from "./SettingNicknameComponent.vue?vue&type=style&index=0&id=29eca157&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eca157",
  null
  
)

export default component.exports